import { apiRequest } from './api';

export const PublicShareService = {
    getProfile(username) {
        return apiRequest(`/share/profile/${encodeURIComponent(username)}`, { authenticated: false });
    },

    getWatchlist(username) {
        return apiRequest(`/share/watchlist/${encodeURIComponent(username)}`, { authenticated: false });
    },

    getCoin(coinId) {
        return apiRequest(`/share/coin/${encodeURIComponent(coinId)}`, { authenticated: false });
    },

    getAchievement(achievementId) {
        return apiRequest(`/share/achievement/${encodeURIComponent(achievementId)}`, { authenticated: false });
    },

    getCollection(collectionId, username) {
        const params = username ? { username } : undefined;
        return apiRequest(`/share/collection/${encodeURIComponent(collectionId)}`, { authenticated: false, params });
    },
};
